import styled from 'styled-components';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { track } from '../../../analytics/analytics';
import { SearchNavigationHook } from '../SearchNavigationHook';
import { SearchInputForm } from '../SearchInput/SearchInputForm';


const trackClick = (filter) => () => {
  track({ category: 'SearchButton', action: 'Click', label: filter.q });
};

const Wrapper = styled.div`
  input {
    border-radius: .3125rem;
  }
`;

const handleKeyPress = (e) => {
  if (e.key === 'Enter') {
    e.target.blur();
  }
};

const Submit = styled.input`
  &.btn:focus {
    box-shadow: 0 0 0 2px var(--blue-brdr);
    border-color: var(--blue-brdr);
  }
`;

export const SearchInputFilterView = ({
  filter,
  router,
  action,
  submit,
  label,
  id,
  placeholder = 'Keywords',
}) => {
  const [value, setValue] = useState(filter.q);

  const onHistoryChange = () => {
    setValue(filter.q);
  };

  const navigate = SearchNavigationHook(router, onHistoryChange);

  const addCustomParams = () => (query, params) => {
    if (value?.length) {
      params.set('q', value.toString());
    } else {
      params.delete('q');
    }
  };

  return (
    <Wrapper className="mb-3">
      <SearchInputForm
        filter={filter}
        id={id}
        action={action}
        label={label}
        placeholder={placeholder}
        handleChange={setValue}
        handleKeyPress={handleKeyPress}
        name="q"
        handleSubmit={() => {
          navigate(addCustomParams());
        }}
        value={value}
      >
        {submit || (
          <div className="input-group-append">
            <Submit
              type="submit"
              className="btn btn-outline-primary amp-track"
              onClick={trackClick(filter)}
              value="Find"
              data-vars-track-category="SearchInput"
              data-vars-track-action="Submit"
              data-vars-track-label=""
            />
          </div>
        )}
      </SearchInputForm>
    </Wrapper>
  );
};

export const SearchInputFilter = withRouter(SearchInputFilterView);

SearchInputFilter.propTypes = {
  action: PropTypes.string,
  submit: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  label: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  placeholder: PropTypes.string,
  id: PropTypes.string,
  filter: PropTypes.shape({
    q: PropTypes.string,
  }).isRequired,
};

SearchInputFilterView.propTypes = {
  ...SearchInputFilterView.propTypes,
  router: PropTypes.shape({
  }).isRequired,
};
